// extracted by mini-css-extract-plugin
export default {"page":"IconList_page__HtgCK","name":"IconList_name__RnSpg","row":"IconList_row__XIksb","icon":"IconList_icon__sGl1M"};